import { FaTrash } from "react-icons/fa";
// import "rc-slider/assets/index.css";
function FilterProduct({
  filterInputs,
  setFilterInputs,
  search,
  resetFilters
}) {
  return (
    <>
      <div
        className="modal fade"
        id="filterModalProduct"
        aria-labelledby="filterModalLabel"
        aria-hidden="true"
        style={{ background: "rgba(1,1,1,0.5)" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content" style={{ minHeight: "100%" }}>
            <div className="modal-header">
              <h5 className="modal-title color-green" id="Label">
                فیلتر محصول
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="row m-1">
                <div className="col-4">
                  <label htmlFor="titleTour" className="form-label">
                    عنوان:
                  </label>
                </div>
                <div className="col-8">
                  <input
                    type="text"
                    id="titleTour"
                    className="form-control"
                    name="title"
                    value={filterInputs.title}
                    onChange={e => {
                      setFilterInputs({
                        ...filterInputs,
                        title: e.target.value
                      });
                    }}
                  />
                </div>
              </div>
              <div className="row m-1 mt-3">
                <div className="col-4">
                  <label
                    htmlFor="complate_order_count_fromTour"
                    className="form-label"
                  >
                    تعداد سفارشات از :
                  </label>
                </div>
                <div className="col-8">
                  <div className="d-flex">
                    <input
                      type="text"
                      id="order_count_fromTour"
                      className="form-control"
                      name="order_count_from"
                      value={filterInputs.order_count_from}
                      onChange={e => {
                        setFilterInputs({
                          ...filterInputs,
                          order_count_from: e.target.value
                        });
                      }}
                    />
                    <p className=" px-2 m-auto">تا </p>
                    <input
                      type="text"
                      id="order_count_toTour"
                      className="form-control"
                      name="order_count_to"
                      value={filterInputs.order_count_to}
                      onChange={e => {
                        setFilterInputs({
                          ...filterInputs,
                          order_count_to: e.target.value
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row m-1 mt-3">
                <div className="col-4">
                  <label htmlFor="unit_price_fromTour" className="form-label">
                    قیمت واحد از:
                  </label>
                </div>
                <div className="col-8">
                  <div className="d-flex">
                    <input
                      type="text"
                      id="unit_price_fromTour"
                      className="form-control"
                      name="unit_price_from"
                      value={filterInputs.unit_price_from}
                      onChange={e => {
                        setFilterInputs({
                          ...filterInputs,
                          unit_price_from: e.target.value
                        });
                      }}
                    />
                    <p className=" px-2 m-auto">تا </p>
                    <input
                      type="text"
                      id="unit_price_toTour"
                      className="form-control"
                      name="unit_price_to"
                      value={filterInputs.unit_price_to}
                      onChange={e => {
                        setFilterInputs({
                          ...filterInputs,
                          unit_price_to: e.target.value
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row m-1 mt-3">
                <div className="col-4">
                  <label
                    htmlFor="supplier_count_fromTour"
                    className="form-label"
                  >
                    تعداد فروشگاه های موجود از:
                  </label>
                </div>
                <div className="col-8">
                  <div className="d-flex">
                    <input
                      type="text"
                      id="supplier_count_fromTour"
                      className="form-control"
                      name="supplier_count_from"
                      value={filterInputs.supplier_count_from}
                      onChange={e => {
                        setFilterInputs({
                          ...filterInputs,
                          supplier_count_from: e.target.value
                        });
                      }}
                    />
                    <p className=" px-2 m-auto">تا </p>
                    <input
                      type="text"
                      id="supplier_count_toTour"
                      className="form-control"
                      name="supplier_count_to"
                      value={filterInputs.supplier_count_to}
                      onChange={e => {
                        setFilterInputs({
                          ...filterInputs,
                          supplier_count_to: e.target.value
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row m-1 mt-3">
                <div className="col-4">
                  <label
                    htmlFor="total_inventory_count_fromTour"
                    className="form-label"
                  >
                    مجموع فروش از :
                  </label>
                </div>
                <div className="col-8">
                  <div className="d-flex">
                    <input
                      type="text"
                      id="total_inventory_count_fromTour"
                      className="form-control"
                      name="total_inventory_count_from"
                      value={filterInputs.total_inventory_count_from}
                      onChange={e => {
                        setFilterInputs({
                          ...filterInputs,
                          total_inventory_count_from: e.target.value
                        });
                      }}
                    />
                    <p className=" px-2 m-auto">تا </p>
                    <input
                      type="text"
                      id="total_inventory_count_toTour"
                      className="form-control"
                      name="total_inventory_count_to"
                      value={filterInputs.total_inventory_count_to}
                      onChange={e => {
                        setFilterInputs({
                          ...filterInputs,
                          total_inventory_count_to: e.target.value
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row m-1 mt-3">
                <div className="col-4">
                  <label
                    htmlFor="total_inventory_count_fromTour"
                    className="form-label"
                  >
                    تعداد اضافه به سبد خرید از :
                  </label>
                </div>
                <div className="col-8">
                  <div className="d-flex">
                    <input
                      type="text"
                      id="add_to_basket_count_fromTour"
                      className="form-control"
                      name="add_to_basket_count_from"
                      value={filterInputs.add_to_basket_count_from}
                      onChange={e => {
                        setFilterInputs({
                          ...filterInputs,
                          add_to_basket_count_from: e.target.value
                        });
                      }}
                    />
                    <p className=" px-2 m-auto">تا </p>
                    <input
                      type="text"
                      id="add_to_basket_count_toTour"
                      className="form-control"
                      name="add_to_basket_count_to"
                      value={filterInputs.add_to_basket_count_to}
                      onChange={e => {
                        setFilterInputs({
                          ...filterInputs,
                          add_to_basket_count_to: e.target.value
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-evenly align-self-center m-2">
              <button
                type="button"
                className="btn btn-warning px-3 mx-4"
                data-bs-dismiss="modal"
                onClick={resetFilters}
              >
                <FaTrash style={{ color: "white" }} />
              </button>
              <button
                type="button"
                className="btn btn-success px-5 mx-4"
                data-bs-dismiss="modal"
                onClick={search}
              >
                ثبت
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FilterProduct;
